import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { message } from 'antd';

function withNavigate(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        const location = useLocation();
        const searchParams = new URLSearchParams(window.location.search);

        const [messageApi, contextHolder] = message.useMessage();
        const onMessage = (type, content) => {
            messageApi.open({
                type,
                content,
            });
        };

        return (
            <Component
                {...props}
                navigate={navigate}
                location={location}
                contextHolder={contextHolder}
                message={message}
                messageApi={messageApi}
                onMessage={onMessage}
                searchParams={searchParams}
            />
        );
    };
}

export default withNavigate;
